import React, { Component }  from 'react';
import { connect } from 'react-redux';
import classes from './Welcome.css';

class Welcome extends Component {
    render () {
        if (this.props.mulchYear)
        {
        return ( 
    <div className={classes.Welcome}>
        <h4>Welcome to Mulch 2.0</h4>
        <p>Orders are open until {this.props.mulchYear.lastSaleDay}</p>
    </div>
        )
    }
    else {
        return (
            <div />
        )
    } 

}
}

const mapStateToProps = state => {
    return {
      mulchYear: state.orders.mulchYear
    };
};

export default connect(mapStateToProps)(Welcome);


// WEBPACK FOOTER //
// ./src/components/Welcome/Welcome.js